import { useRef,MutableRefObject } from "react";

/**
 * If a second request is done while first is still in progress,
 * it will wait the first process to finish and return its value
 */
export function lockFunction<T, P extends Promise<T>>(executor:lockFunction.Executor<P>): lockFunction.Executor<P>
{
    const process = {} as lockFunction.Ref<P>;
    return lockFunction.withRef(executor, process);
}

export namespace lockFunction
{
    export type Executor<P> = (this:any, ...args:any[]) => P
    export type Ref<P> = MutableRefObject<P | undefined>;

    export function withRef<T, P extends Promise<T>>(executor:Executor<P>, process:Ref<P>): Executor<P>
    {
        /** Replacing get method with lazy call */
        return function(this:any, ...args:any[])
        {
            if(process.current) { return process.current; }
            process.current = executor.call(this, ...args);
            process.current.finally(() => process.current = undefined);
            return process.current;
        };
    }
}
/**
 * If a second request is done while first is still in progress,
 * it will wait the first process to finish and return its value
 */
export function useLock<T, P extends Promise<T>>(executor:(this:any, ...args:any[]) => P): typeof executor
{
    const process = useRef<P>();
    return lockFunction.withRef(executor, process);
}